import { Component, type ErrorInfo, type ReactNode } from 'react';

interface State {
  failed: boolean;
}

/** Catches render errors so a bug shows a friendly page instead of a blank one. */
export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  override state: State = { failed: false };

  static getDerivedStateFromError(): State {
    return { failed: true };
  }

  override componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Penfold Says hit a snag', error, info.componentStack);
  }

  override render() {
    if (!this.state.failed) return this.props.children;
    return (
      <main className="fallback" role="alert">
        <h1>Spilt the pint.</h1>
        <p>Something went wrong showing this page. It’s not you, it’s us.</p>
        <p>
          <a className="pill-button" href="/">
            Back to the map
          </a>
        </p>
      </main>
    );
  }
}
